"use client";

import { clsx } from "@trydig/ui";
import { CartContent } from "~/features/cart/CartContent";
import { CartHeader } from "~/features/cart/CartHeader";
import { CartTrigger } from "~/features/cart/CartTrigger";
import { Modal } from "~/features/modal";
import { useCart } from "~/lib/hooks/useCart";
import styles from "./Cart.module.css";

export interface CartTriggerProps {
	styles: string;
	activeStyles: string;
	onClick?: () => void;
}

export const Cart = (cartTriggerProps: CartTriggerProps) => {
	const { modal } = useCart();

	const toggleModal = () => {
		if (modal.isOpen) {
			//   eventViewCart({
			//     currency: currency || "",
			//     items: items.map((item) => convertCartToGTagItem(item)),
			//     value: cart.summary?.prices.totalAsNumber
			//   });
		}
		modal.toggleModal();
	};

	return (
		<div>
			<CartTrigger {...cartTriggerProps} onClick={toggleModal} />

			<Modal isOpen={modal.isOpen} callback={modal.closeModal} className={styles["cart-modal"]}>
				<div className={clsx(styles["cart-dialog"])}>
					<CartHeader />

					<CartContent />
				</div>
			</Modal>
		</div>
	);
};
